import { styled } from "styled-components";

export const ShuffleWrapper = styled.div`
  padding: 80px 0 0;
  @media all and (max-width: 768px) {
    padding: 8.889vw 0 0;
  }
`;

export const ShuffleClassNavList = styled.ul`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  position: fixed;
  top: 100px;
  left: 0;
  width: 100%;
  background-color: #fbfbfb;
  z-index: 1;
  li {
    font-size: 24px;
    line-height: 1.3;
    font-weight: bold;
    cursor: pointer;
    color: #c1c1c1;
    &.active {
      color: #171717;
    }
  }
  @media all and (max-width: 1024px) {
    top: 80px;
  }
  @media all and (max-width: 768px) {
    top: 60px;
    gap: 5.208vw;
    height: 10.417vw;
    li {
      font-size: 3.385vw;
    }
  }
`;

export const ShuffleWrap = styled.div`
  .title-area {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 280px;
    h6 {
      font-family: "AnekLatin-semibold";
      font-weight: 600;
      font-size: 46px;
      color: #171717;
    }
    p {
      font-size: 24px;
      line-height: 1.3;
      color: #242424;
    }
    & + div {
      flex: 1;
    }
  }
  @media all and (max-width: 768px) {
    .title-area {
      gap: 2.344vw;
      h6 {
        font-size: 7.813vw;
      }
      p {
        font-size: 4.167vw;
      }
    }
  }
`;

export const ShuffleTitleWrapContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  padding: 120px 0;
  @media all and (max-width: 1200px) {
    padding: 100px 0;
    gap: 30px;
  }
  @media all and (max-width: 768px) {
    padding: 10.417vw 0;
    gap: 5.208vw;
    flex-direction: column;
    justify-content: center;
  }
`;

export const ShuffleTitleWrap = styled.div`
  .img-area {
    img {
      width: 520px;
      height: 340px;
    }
  }
  .text-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 40px;
    .title-text-wrap {
      display: flex;
      align-items: end;
      gap: 24px;
      h6 {
        font-family: "AnekLatin-semibold";
        font-size: 72px;
        line-height: 72px;
        color: #171717;
      }
      p {
        font-size: 24px;
        line-height: 1.3;
        color: #242424;
      }
    }
    .sub-text-wrap {
      display: flex;
      flex-direction: column;
      gap: 16px;
      p {
        word-break: keep-all;
      }
      .sub-text {
        font-size: 24px;
        line-height: 1.3;
        font-weight: 700;
        color: #242424;
        .mobile {
          display: none;
        }
      }
      .desc-text {
        font-size: 20px;
        line-height: 1.4;
        color: #242424;
        .mobile {
          display: none;
        }
      }
    }
  }
  @media all and (max-width: 1024px) {
    .img-area {
      img {
        width: 400px;
        height: 280px;
      }
    }
    .text-area {
      gap: 24px;
      .title-text-wrap {
        gap: 16px;
        h6 {
          font-size: 60px;
          line-height: 1;
        }
        p {
          font-size: 20px;
        }
      }
      .sub-text-wrap {
        gap: 12px;
        .sub-text {
          font-size: 20px;
        }
        .desc-text {
          font-size: 16px;
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    .img-area {
      img {
        width: 90vw;
        height: 60vw;
      }
    }
    .text-area {
      gap: 3.125vw;

      text-align: center;
      .title-text-wrap {
        gap: 3.385vw;
        justify-content: center;
        h6 {
          font-size: 9.115vw;
        }
        p {
          display: none;
        }
      }
      .sub-text-wrap {
        gap: 3.125vw;
        .sub-text {
          font-size: 4.167vw;
          .mobile {
            display: block;
          }
        }
        .desc-text {
          font-size: 3.646vw;
          word-break: keep-all;
          br {
            display: none;
            &.mobile {
              display: block;
            }
          }
        }
      }
    }
  }
`;

export const refWrap = styled.div`
  border-top: 1px solid #dfdfdf;
`;

export const ScheduleWrap = styled(refWrap)``;
export const PricingWrap = styled(refWrap)`
  background: #f7f7f7;
`;
export const VideoWrap = styled(refWrap)``;
export const InstructorsWrap = styled(refWrap)`
  background: #f7f7f7;
`;

export const refContainer = styled.div`
  display: flex;
  gap: 80px;
  padding: 60px 0;
  @media all and (max-width: 1200px) {
    gap: 40px;
  }
  @media all and (max-width: 1180px) {
    flex-direction: column;
  }
  @media all and (max-width: 1024px) {
    flex-direction: column;
    gap: 50px;
  }
  @media all and (max-width: 768px) {
    gap: 6.51vw;
    padding: 6.51vw 0;
  }
`;

export const ScheduleContainer = styled(refContainer)``;

export const ScheduleListItem = styled.li`
  padding: 20px 0;
  border-top: 1px solid #171717;
  display: flex;
  gap: 40px;
  justify-content: space-between;
  .day-area {
    width: 100px;
    p {
      font-size: 20px;
      line-height: 1.4;
      font-weight: 700;
      color: #171717;
      &.blue {
        color: #0073cb;
      }
      &.red {
        color: #df1d1d;
      }
    }
  }
  .class-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      dl {
        display: flex;
        align-items: center;
        gap: 16px;
        dt {
          min-width: 140px;
          font-size: 16px;
          line-height: 1.5;
          color: #6f6f6f;
        }
        dd {
          font-size: 16px;
          line-height: 1.5;
          font-weight: bold;
          color: #171717;
        }
      }
      p {
        color: #ff784d;
        font-weight: bold;
        font-size: 16px;
        line-height: 1.5;
        min-width: 160px;
        text-align: left;
      }
    }
  }
  @media all and (max-width: 768px) {
    padding: 3.125vw 0;
    flex-direction: column;
    gap: 5.208vw;
    .day-area {
      width: auto;
      display: flex;
      align-items: center;
      gap: 2.344vw;
      p {
        font-size: 3.906vw;
      }
    }
    .class-area {
      gap: 1.563vw;
      li {
        dl {
          gap: 2.083vw;
          dt {
            min-width: 26.042vw;
            font-size: 3.385vw;
          }
          dd {
            font-size: 3.385vw;
            max-width: 39.063vw;
            word-break: keep-all;
          }
        }
        p {
          font-size: 3.385vw;
          min-width: 28.646vw;
        }
      }
    }
  }
`;

export const PricingContainer = styled(refContainer)``;

export const ShufflePricingListWrap = styled.ul`
  flex: 1;
  > p {
    font-size: 14px;
    line-height: 1.5;
    color: #6f6f6f;
    &:first-of-type {
      margin-top: 16px;
    }
    br {
      &.mobile {
        display: none;
      }
    }
  }
  > li {
    &:not(:first-of-type) {
      margin-top: 40px;
    }
    dl {
      border: 1px solid #dfdfdf;
      border-radius: 8px;
      overflow: hidden;
      width: 100%;
      dt {
        color: #fbfbfb;
        padding: 8px 16px;
        font-weight: bold;
        font-size: 24px;
        line-height: 1.3;
        &.grey {
          background-color: #555555;
        }
        &.black {
          background-color: #171717;
        }
      }
      > div {
        &:not(:last-child) {
          border-bottom: 1px solid #dfdfdf;
        }
        padding: 32px 40px;
        .sub-text {
          margin-top: 20px;
          font-weight: bold;
          color: #171717;
          font-size: 16px;
        }
        div {
          display: flex;
          align-items: center;
          gap: 16px;
          > p {
            color: #242424;
            font-weight: bold;
            font-size: 20px;
            line-height: 1.4;
            gap: 40px;
            min-width: 220px;
          }
        }
      }
      ul {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 16px;
        > li {
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: space-between;
          > div {
            width: calc(100% - 190px);
            > p {
              color: #6f6f6f;
              font-weight: bold;
              font-size: 16px;
              line-height: 1.5;
            }
          }
          > span {
            display: block;
            width: 190px;
            text-align: left;
            font-weight: bold;
            color: #171717;
            font-size: 16px;
            line-height: 1.5;
          }
        }
      }
    }
  }
  @media all and (max-width: 1200px) {
    > li {
      dl {
        > div {
          > div {
            > p {
              min-width: 160px;
            }
          }
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    > p {
      font-size: 3.125vw;
      word-break: keep-all;
      &:first-of-type {
        margin-top: 3.646vw;
      }
      br {
        &.mobile {
          display: block;
        }
      }
    }
    > li {
      &:not(:first-of-type) {
        margin-top: 7.813vw;
      }
      dl {
        border-radius: 1.563vw;
        dt {
          padding: 2.083vw 3.125vw;
          font-size: 4.167vw;
        }
        > div {
          padding: 5.208vw 6.25vw;

          .sub-text {
            margin-top: 4.167vw;
            font-size: 3.385vw;
          }
          > div {
            gap: 3.125vw;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            > p {
              font-size: 3.906vw;
              gap: 5.208vw;
            }
          }
        }
        ul {
          gap: 3.125vw;
          width: 100%;
          > li {
            width: 100%;
            display: flex;
            justify-content: space-between;
            > div {
              > p {
                font-size: 3.646vw;
              }
            }
            > span {
              min-width: 41.667vw;
              font-size: 3.646vw;
              text-align: right;
            }
          }
        }
      }
    }
  }
`;

// export const refContainer = styled.div`
//   display: flex;
//   gap: 80px;
//   padding: 60px 0;
//   @media all and (max-width: 1200px) {
//     gap: 40px;
//   }
//   @media all and (max-width: 1180px) {
//     flex-direction: column;
//   }
//   @media all and (max-width: 1024px) {
//     flex-direction: column;
//     gap: 50px;
//   }
//   @media all and (max-width: 768px) {
//     gap: 6.51vw;
//     padding: 6.51vw 0;
//   }
// `;
export const VideoContainer = styled(refContainer)`
  gap: 20px;
  .title-area {
    width: 160px;
  }
  @media all and (max-width: 1180px) {
    .title-area {
      width: auto;
    }
  }
`;

export const ShuffleVideoListWrap = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  li {
    width: calc(25% - 60px / 4);
    a {
      display: flex;
      flex-direction: column;
      gap: 12px;
      img {
        width: 100%;
        height: 340px;
      }
      .text-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        p {
          font-weight: bold;
          font-size: 20px;
          line-height: 1.4;
          color: #242424;
        }
        span {
          font-size: 14px;
          color: #6f6f6f;
          line-height: 1.4;
        }
      }
    }
  }
  @media all and (max-width: 1180px) {
    li {
      a {
        img {
          /* height: 38.898vw; */
          height: auto;
        }
      }
    }
  }
  @media all and (max-width: 1024px) {
    li {
      width: calc(50% - 10px);
      a {
      }
    }
  }

  @media all and (max-width: 640px) {
    li {
      width: 100%;
      a {
        img {
          height: auto;
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    li {
      width: calc(50% - 10px);
    }
  }
  @media all and (max-width: 768px) {
    gap: 2.604vw;
    li {
      a {
        .text-wrap {
          gap: 0.781vw;
          p {
            font-size: 3.906vw;
          }
          span {
            font-size: 3.385vw;
          }
        }
      }
    }
  }
  @media all and (max-width: 640px) {
    gap: 4.688vw;
    li {
      width: 100%;
    }
  }
`;
export const InstructorsContainer = styled(refContainer)`
  @media all and (max-width: 1180px) {
    flex-direction: column;
  }
`;

export const ShuffleInstructorsListWrap = styled.ul`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  li {
    width: calc(33.333% - 40px / 3);
    a {
      display: flex;
      flex-direction: column;
      gap: 16px;
      i {
        width: 100%;
        height: 340px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        text-align: center;
        font-size: 24px;
        line-height: 1.3;
        color: #242424;
        font-weight: bold;
      }
    }
  }
  @media all and (max-width: 1180px) {
    gap: 1.695vw;
    li {
      width: calc(33.333% - 3.39vw / 3);
      a {
        i {
          height: 38.898vw;
        }
      }
    }
  }
  @media all and (max-width: 1024px) {
    gap: 20px;
    flex-wrap: wrap;
    li {
      width: calc(50% - 10px);
      a {
        i {
          height: 500px;
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    li {
      a {
        i {
          height: 55.556vw;
        }
      }
    }
  }
  @media all and (max-width: 640px) {
    gap: 4.444vw;
    li {
      width: 100%;
      a {
        i {
          height: auto;
        }
        p {
          font-size: 3.556vw;
        }
      }
    }
  }
`;
